import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import { Skeleton } from "@/components/ui/skeleton";
import { restoreSession } from "@/lib/api-client";
import { useAuthStore } from "@/lib/auth-store";

export function ProtectedRoute() {
  const isAuthenticated = useAuthStore((state) => state.accessToken !== null);
  // The access token is held only in memory, so a full page load always
  // arrives here unauthenticated — even when the HttpOnly refresh cookie
  // is still valid. Attempt one silent refresh before deciding; bouncing
  // straight to /login would log the user out on every reload.
  const [restoring, setRestoring] = useState(() => !isAuthenticated);

  useEffect(() => {
    if (!restoring) return;
    let cancelled = false;
    void restoreSession().finally(() => {
      if (!cancelled) setRestoring(false);
    });
    return () => {
      cancelled = true;
    };
  }, [restoring]);

  if (restoring) {
    return (
      <div
        className="flex min-h-full flex-col gap-4 p-4 sm:gap-6 sm:p-6"
        aria-busy="true"
        aria-label="Đang khôi phục phiên đăng nhập"
      >
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-48 w-full" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
